<template>
  <layout>
    <div slot="banner"></div>
    <div class="empty-box"></div>

    <!-- 介绍 -->
    <Introduction
      :data="data.introduction"
    />

    <div class="finalist">
      <div class="layout-content">
        <div
          v-for="(item) in data.finalist.content"
          :key="item.alias"
        >
          <div class="title-wrap">
            <SubTitle :text="item.title"  />
          </div>

          <div
            class="content-wrap"
          >
            <div
              class="content"
              v-for="each in item.list"
              :key="each.title"
            >
              <div class="image"><img :src="each.image"></div>

              <div class="intro">
                <div class="content-title">
                  {{ each.title }}
                  <div
                    class="span"
                    :data-type="each.alias"
                  >
                    {{ each.type_title }}
                  </div>
                </div>

                <div class="intro-content">
                  <div class="intro-content-title">参赛作品：</div>
                  <div class="intro-content-info">{{ each.product }}</div>
                </div>
                <div class="intro-content">
                  <div class="intro-content-title">参赛成员：</div>
                  <div class="intro-content-info">{{ each.member }}</div>
                </div>
                <div class="intro-content">
                  <div class="intro-content-title">作品简介：</div>
                  <div class="intro-content-info">{{ each.pro_intro }}</div>
                </div>
              </div>

              <div class="bottom-line" :data-type="item.alias"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '../../components/layout/layout'
import SubTitle from '../../components/SubTitle'
import Introduction from '../../components/IntroductionNew'

import { mapState } from 'vuex'

export default {
  name: 'Past2022',

  components: {
    layout,
    SubTitle,
    Introduction
  },

  computed: {
    ...mapState([
      'isEnLang',
      'isMobile'
    ]),
    data () {
      return this.$t('past2022')
    }
  }
}
</script>

<style lang="scss" scoped>

.empty-box {
  width: 100vw; height: 68px;

  @include mobile {
    height: 55px;
  }
}

.page-title {
  .title-competition-ch {
    margin-bottom: 12px;
    font-size: 60px; font-family:  DIN-BlackItalic;
    color: #303030;
    line-height: 82px;
    letter-spacing: 2px;

    @include mobile {
      font-size: 28px;
      line-height: 38px;
      letter-spacing: 1px;
    }
  }

  .title-competition-en {
    font-size: 23px; font-family: Alibaba-PuHuiTi-Heavy;
    color: #303030;
    line-height: 31px;
    letter-spacing: 6px;

    @include mobile {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      letter-spacing: 1px;
    }
  }
}

.finalist {
  padding: 86px 0 141px;
  background: $bgGrey;

  @include mobile {
    padding: 24px 0 75px;
  }
}

.title-wrap {
  margin-top: 120px;

  & ::v-deep .title {
    font-family: 'fz';
  }

  @include mobile {
    margin-top: 50px;
  }
}

.content-wrap {
  display: flex; justify-content: center; align-items: stretch;
  gap: 24px;

  @include mobile {
    flex-direction: column;
    gap: 16px;
  }
}
.content {
  display: flex; flex-direction: column;
  width: 384px;

  @include mobile {
    width: 100%;
  }
}
.image {
  flex: none;
  width: 100%;

  img {
    width: 100%; height: 253px;
    object-fit: cover;
  }

  @include mobile {
    aspect-ratio: 335 / 221;

    img {
      height: 100%;
    }
  }
}
.intro {
  flex: 1;
  padding: 0 20px 24px;
  background-color: #fff;

  @include mobile {
    padding-bottom: 16px;
  }
}
.content-title {
  display: flex;
  margin-bottom: 19px;
  padding: 20px 0 19px;
  font-size: 18px; font-weight: 600;
  color: #000;
  line-height: 26px;
  border-bottom: 1px dashed rgba(#000000, 0.15);

  @include mobile {
    font-size: 16px;
    margin-bottom: 16px;
    padding: 16px 0 12px;
  }

  & .span {
    height: 20px;
    margin-top: 3px;
    margin-left: 8px;
    padding: 2px 5px;
    font-size: 12px;
    line-height: 18px;

    @include mobile {
      line-height: 18px;
    }
  }

  & [data-type="ai"] {
    background-color: #FEE7E5;
    color: #E1574D;
  }
  & [data-type="blockchain"] {
    background-color: #F2EDFF;
    color: #7652E1;
  }
  & [data-type="pm"] {
    background-color: #E7F2FF;
    color: #376EFD;
  }
}
.intro-content {
  display: flex;
  margin-bottom: 14px;
  font-size: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  @include mobile {
    margin-bottom: 10px;
    font-size: 13px;
  }
}
.intro-content-title {
  flex: none;
  color: rgba(#000, 0.8);
  line-height: 24px;
}
.intro-content-info {
  flex: 1;
  color: rgba(#000, 0.6);
  line-height: 24px;
}
.bottom-line {
  height: 12px;

  &[data-type="first"] {
    background: linear-gradient(270deg, #FFF7E6 0%, #F7DDA1 100%);
  }
  &[data-type="second"] {
    background: linear-gradient(270deg, #F4F4F4 0%, #DDDDDD 100%);
  }
  &[data-type="third"] {
    background: linear-gradient(270deg, #FEF4EF 0%, #E1C6BA 100%);
  }
}

</style>
